import { render, staticRenderFns } from "./ComprehensiveEvaluation.vue?vue&type=template&id=0b1c1a02&scoped=true"
import script from "./ComprehensiveEvaluation.vue?vue&type=script&lang=js"
export * from "./ComprehensiveEvaluation.vue?vue&type=script&lang=js"
import style0 from "./ComprehensiveEvaluation.vue?vue&type=style&index=0&id=0b1c1a02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c1a02",
  null
  
)

export default component.exports